import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Fan = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M15 4C15 3.44772 15.4477 3 16 3C20.2681 3 24 5.99494 24 10C24 12.0015 23.068 13.7508 21.6028 15H28C28.2652 15 28.5196 15.1054 28.7071 15.2929C28.8946 15.4804 29 15.7348 29 16C29 20.2681 26.0051 24 22 24C19.9985 24 18.2492 23.068 17 21.6028V28C17 28.2652 16.8946 28.5196 16.7071 28.7071C16.5196 28.8946 16.2652 29 16 29C11.7319 29 8 26.0051 8 22C8 19.9985 8.93203 18.2492 10.3972 17H4C3.44772 17 3 16.5523 3 16C3 11.7319 5.99494 8 10 8C12.0015 8 13.7508 8.93203 15 10.3972V4ZM14.9322 15C14.5268 12.0588 12.3627 10 10 10C7.63727 10 5.4732 12.0588 5.06785 15H14.9322ZM15 17.0678C12.0588 17.4732 10 19.6373 10 22C10 24.3627 12.0588 26.5268 15 26.9321V17.0678ZM17.0678 17H26.9321C26.5268 19.9412 24.3627 22 22 22C19.6373 22 17.4732 19.9412 17.0678 17ZM17 14.9322C19.9412 14.5268 22 12.3627 22 10C22 7.63727 19.9412 5.4732 17 5.06785V14.9322Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Fan;
